<div>
  <input type="text" (input)="searchData($any($event.target).value)" placeholder="Search...">
</div>

<table>
  <thead>
    <tr>
      <th (click)="sortData('id')">ID</th>
      <th (click)="sortData('name')">Name</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of data">
      <td>{{ item.id }}</td>
      <td>{{ item.name }}</td>
    </tr>
  </tbody>
</table>

<div>
  <button (click)="goToFirstPage()" [disabled]="currentPage === 1">First</button>
  <button (click)="goToPreviousPage()" [disabled]="currentPage === 1">Previous</button>
  <button *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(i + 1)">{{ i + 1 }}</button>
  <button (click)="goToNextPage()" [disabled]="currentPage === totalPages">Next</button>
  <button (click)="goToLastPage()" [disabled]="currentPage === totalPages">Last</button>
</div>

<div>
  <button (click)="loadMore()">Load More</button>
</div>
